module.exports = __webpack_public_path__ + "static/img/spring_tab1_selected.7efd206.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/newVersion/spring_tab1_selected.png
// module id = 357
// module chunks = 32